@if (dashboard; as d) {
  <!-- Estados de ejecución -->
  <div class="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4"
       [ngClass]="compact ? 'lg:grid-cols-4' : 'lg:grid-cols-8 gap-3 mb-6'">
    @for (item of statusCards; track item.key) {
      <div class="rounded-xl border border-gray-200 dark:border-gray-700 text-center"
           [ngClass]="[item.color, compact ? 'p-2' : 'p-3']">
        <p class="font-bold" [ngClass]="compact ? 'text-xl' : 'text-2xl'">
          {{ num(d.totals[item.key]) }}
        </p>
        <p class="text-xs mt-1 opacity-75">{{ item.label }}</p>
      </div>
    }
  </div>

  <div class="grid grid-cols-1 gap-4 mb-4"
       [ngClass]="showDetails ? 'md:grid-cols-3' : 'md:grid-cols-1'">
    <!-- Tasas -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">Tasas</h3>
      <dl class="space-y-2">
        @for (r of rateRows; track r.key) {
          <div class="flex justify-between items-center">
            <dt class="text-xs text-gray-500 dark:text-gray-400">{{ r.label }}</dt>
            <dd class="text-sm font-semibold text-gray-900 dark:text-white">{{ pct(d.rates[r.key]) }}</dd>
          </div>
        }
      </dl>
    </div>

    @if (showDetails) {
      <!-- Pasos -->
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">Pasos de ejecución</h3>
        <dl class="space-y-2">
          @for (s of stepRows; track s.key) {
            <div class="flex justify-between items-center">
              <dt class="text-xs text-gray-500 dark:text-gray-400">{{ s.label }}</dt>
              <dd class="text-sm font-semibold text-gray-900 dark:text-white">{{ num(d.steps[s.key]) }}</dd>
            </div>
          }
        </dl>
      </div>

      <!-- Duración -->
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">Duración</h3>
        <dl class="space-y-2">
          @for (dur of durationRows; track dur.key) {
            <div class="flex justify-between items-center">
              <dt class="text-xs text-gray-500 dark:text-gray-400">{{ dur.label }}</dt>
              <dd class="text-sm font-semibold text-gray-900 dark:text-white">
                {{ formatDuration(d.durations[dur.key]) }}
              </dd>
            </div>
          }
        </dl>
      </div>
    }
  </div>

  @if (showErrors) {
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">Errores más frecuentes</h3>
      @if (topErrors.length) {
        <div class="space-y-2">
          @for (e of topErrors; track $index) {
            <div class="flex items-center gap-3">
              <span class="shrink-0 w-7 h-7 rounded-full bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 text-xs font-bold flex items-center justify-center">
                {{ e.count }}
              </span>
              <p class="text-xs text-gray-600 dark:text-gray-300 font-mono truncate flex-1" [title]="e.message">
                {{ e.message }}
              </p>
            </div>
          }
        </div>
      } @else {
        <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-2">No hay errores recientes.</p>
      }
    </div>
  }
}
